import React, { ComponentType } from 'react'
import { Segment } from 'semantic-ui-react'

const SafeSegment = Segment as unknown as ComponentType<any>

type Props = {
  height?: string | undefined
  mode: string
}

function NavSpacer(
  props: Props
): JSX.Element {
  const {
    height,
    mode
  } = props
  const segmentHeight = height || '64px'
  const segmentOrEmpty = mode === 'segment'
    ? 'segment'
    : 'empty'
  const style = {
    height: segmentHeight
  }

  if (segmentOrEmpty === 'segment') {
    return (
      <SafeSegment
        attached
        compact
        className="left-segment"
      >
        <div style={ style } />
      </SafeSegment>
    )
  }
  return (
    <div style={ style } />
  )
}

export default NavSpacer
